<template>
  <div class="ai-model-management">
    <!-- 顶部标题 -->
    <div class="page-header">
      <h2>大模型管理系统</h2>
      <p>统一管理模型类型、密钥和智能体工作流</p>
    </div>

    <!-- 菜单切换 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick" type="border-card">
      <el-tab-pane label="模型类型管理" name="modelType">
        <model-type ref="modelTypeRef"  v-if="activeTab=='modelType'"></model-type>
      </el-tab-pane>
      
      <el-tab-pane label="模型密钥管理" name="modelKey">
        <model-key ref="modelKeyRef" @forActiveTab="forActiveTab" v-if="activeTab=='modelKey'"></model-key>
      </el-tab-pane>

      <!-- 修复：正确使用 AiStandardCourse 组件 -->
      <el-tab-pane label="共享密钥查询" name="modelKeyShare">
        <model-key-share ref="modelKeyShareRef" v-if="activeTab=='modelKeyShare'"></model-key-share>
      </el-tab-pane>
      
      <el-tab-pane label="标准模型管理" name="workflow">
        <workflow ref="workflowRef" v-if="activeTab=='workflow'"></workflow>
      </el-tab-pane>
	  <el-tab-pane label="敏感词库管理" name="monitorWork">
	    <monitorWork ref="monitorWork" v-if="activeTab=='monitorWork'"></monitorWork>
	  </el-tab-pane>
	  
    </el-tabs>
  </div>
</template>

<script>
import ModelType from './components/ModelType.vue'
import ModelKey from './components/ModelKey.vue'
import Workflow from './components/Workflow.vue'
import MonitorWork from './components/MonitorWork.vue'
// 修复：组件大驼峰规范
import AiStandardCourse from './components/AiStandardCourse.vue'
import ModelKeyShare from './components/ModelKeyShare.vue'
export default {
  name: 'AiModelManagement',
  components: {
    ModelType,
    ModelKey,
    Workflow,
    AiStandardCourse,  // 修复
	ModelKeyShare,
	MonitorWork
  },
  data() {
    return {
      activeTab: 'modelType'
    }
  },
  methods: {
	  forActiveTab(val){
	    if(val === 2||val === 3||val==4||val==5){
	      // 1. 先修改v-model绑定的activeTab，UI标签才会真正切换
	      this.activeTab = "workflow";
	      // nextTick 等DOM渲染完成，ref已经可用，再去刷新子组件
	      this.$nextTick(()=>{
	        if(this.$refs.workflowRef){
	          this.$refs.workflowRef.fetchData();
	        }
	      })
	    }
	  },
    handleTabClick(tab) {
      // 切换菜单时，自动刷新对应子组件的数据
      if (tab.name === 'modelType' && this.$refs.modelTypeRef) {
        this.$refs.modelTypeRef.fetchData()
      } else if (tab.name === 'modelKey' && this.$refs.modelKeyRef) {
        this.$refs.modelKeyRef.fetchData()
      } else if (tab.name === 'workflow' && this.$refs.workflowRef) {
        this.$refs.workflowRef.fetchData()
      } 
      // 修复：标准课程标签刷新逻辑
      else if (tab.name === 'aiStandardCourse' && this.$refs.aiStandardCourseRef) {
        this.$refs.aiStandardCourseRef.tolist()
		
      }else if (tab.name === 'modelKeyShare' && this.$refs.modelKeyShare) {
        this.$refs.modelKeyShareRef.fetchData()
		
      }else if (tab.name === 'monitorWork' && this.$refs.monitorWork) {
        this.$refs.monitorWork.getList()
		
      }
    }
  },
  mounted() {
    // 页面加载时，默认加载第一个标签页的数据
    this.$nextTick(() => {
      if (this.$refs.modelTypeRef) {
        // this.$refs.modelTypeRef.fetchData()
      }
    })
  }
}
</script>

<style scoped>
.ai-model-management {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 20px;
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-header h2 {
  margin: 0 0 10px 0;
  color: #303133;
}

.page-header p {
  margin: 0;
  color: #909399;
  font-size: 14px;
}
</style>